"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Paper_1 = __importDefault(require("@material-ui/core/Paper"));

var utils_1 = require("../../../../utils");

var useStyles = utils_1.makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    }
  };
});

var Layout = function Layout(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return react_1.default.createElement(Paper_1.default, {
    className: classes.paper
  }, children);
};

exports.default = Layout;